document.addEventListener('ajaxProduct:added', () => {
  document.dispatchEvent(new CustomEvent('globo.preorder.update.cart'));
});
['sectionsRenderingAPI:cached', 'quickview:loaded', 'product-info:loaded'].forEach((eventName) => {
  document.addEventListener(eventName, () => {
    document.dispatchEvent(new CustomEvent('globo.preorder.collection.filtered'));
  });
});


document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-mobile-chat]');
  if (!button || !window.matchMedia('(max-width: 767px)').matches) return;
  event.preventDefault();
  button.setAttribute('aria-busy', 'true');
  try {
    await customElements.whenDefined('shopify-chat');
    const chat = document.querySelector('shopify-chat');
    if (chat) chat.setAttribute('open', '');
  } finally {
    button.removeAttribute('aria-busy');
  }
});

// Remove the celebratory emoji from product loyalty messages.
(() => {
  const pointsRoot = document.querySelector('.product__info');
  if (!pointsRoot) return;
  const cleanPoints = () => {
    pointsRoot.querySelectorAll("gameball-product-points .gb_prdct_pnts__text").forEach((text) => {
      const nodes = document.createTreeWalker(text, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = nodes.nextNode())) {
        const cleaned = node.nodeValue.replace(/\s*\u{1F389}\uFE0F?/gu, "");
        if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
      }
    });
  };
  const start = () => {
    cleanPoints();
    new MutationObserver(cleanPoints).observe(pointsRoot, {childList:true, subtree:true, characterData:true});
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, {once:true});
  else start();
})();

(() => {
  // Collection-only UI: do not watch homepage animations or app updates.
  if (!document.body.classList.contains('template-collection')) return;
  const panels = new WeakMap();
  const desktop = window.matchMedia('(min-width:769px)');
  let queued = false;
  const refresh = () => {
    queued = false;
    const panel = document.querySelector('body.template-collection #gf-tree');
    if (!panel) return;
    let update = panels.get(panel);
    if (!update) {
      const thumb = document.createElement('div');
      thumb.className = 'ji-panel-scroll-thumb';
      thumb.setAttribute('role', 'scrollbar');
      thumb.setAttribute('aria-controls', panel.id);
      thumb.setAttribute('aria-orientation', 'vertical');
      thumb.setAttribute('aria-valuemin', '0');
      thumb.setAttribute('aria-valuemax', '100');
      thumb.setAttribute('aria-label', panel.querySelector('.gf-filter-heading')?.textContent.trim() || 'Filters');
      thumb.tabIndex = 0;
      panel.append(thumb);
      update = () => {
        panel.style.setProperty("--ji-panel-scroll-offset", panel.scrollTop + "px");
        const range = panel.scrollHeight - panel.clientHeight;
        thumb.hidden = !desktop.matches || range < 3;
        if (thumb.hidden) return;
        const travel = Math.max(0, panel.clientHeight - 86);
        const ratio = Math.min(1, Math.max(0, panel.scrollTop / range));
        thumb.style.transform = 'translateY(' + (panel.scrollTop + 16 + ratio * travel) + 'px)';
        thumb.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
      };
      let drag;
      thumb.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;
        event.preventDefault();
        drag = {y:event.clientY, scroll:panel.scrollTop};
        thumb.setPointerCapture(event.pointerId);
      });
      thumb.addEventListener('pointermove', event => {
        if (!drag) return;
        const travel = Math.max(1, panel.clientHeight - 86);
        panel.scrollTop = drag.scroll + (event.clientY - drag.y) * (panel.scrollHeight - panel.clientHeight) / travel;
      });
      const stop = () => { drag = null; };
      thumb.addEventListener('pointerup', stop);
      thumb.addEventListener('pointercancel', stop);
      thumb.addEventListener('lostpointercapture', stop);
      thumb.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowDown') next = panel.scrollTop + 40;
        else if (event.key === 'ArrowUp') next = panel.scrollTop - 40;
        else if (event.key === 'PageDown') next = panel.scrollTop + panel.clientHeight * .85;
        else if (event.key === 'PageUp') next = panel.scrollTop - panel.clientHeight * .85;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = panel.scrollHeight;
        else return;
        event.preventDefault();
        panel.scrollTop = next;
      });
      panel.addEventListener('scroll', schedule, {passive:true});
      const resize = new ResizeObserver(schedule);
      resize.observe(panel);
      const contents = panel.querySelector('.gf-filter-contents');
      if (contents) resize.observe(contents);
      panels.set(panel, update);
    }
    update();
  };
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }
  new MutationObserver(schedule).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
  window.addEventListener('resize', schedule, {passive:true});
  schedule();
})();

/* Keep Globo price fields in sync with the collection's price query. */
(() => {
  const applyPrice = event => {
    const input = event.target.closest?.('#gf-tree .gf-range-min, #gf-tree .gf-range-max');
    if (!input) return;
    const block = input.closest('.gf-option-block-slider');
    const slider = block?.querySelector('.gf-range-slider');
    const low = block?.querySelector('.gf-range-min');
    const high = block?.querySelector('.gf-range-max');
    if (!slider || !low || !high || !low.value.trim() || !high.value.trim()) return;
    const min = Math.max(Number(slider.dataset.min), Number(low.value.trim().replace(',', '.')));
    const max = Math.min(Number(slider.dataset.max), Number(high.value.trim().replace(',', '.')));
    if (!Number.isFinite(min) || !Number.isFinite(max) || min > max) return;
    const url = new URL(location.href);
    const key = 'gf_' + slider.dataset.id;
    const value = min.toFixed(2) + ':' + max.toFixed(2);
    if (url.searchParams.get(key) === value) return;
    url.searchParams.set(key, value);
    url.searchParams.delete('page');
    location.assign(url.toString());
  };
  document.addEventListener('change', applyPrice, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || !event.target.matches?.('#gf-tree .gf-range-min, #gf-tree .gf-range-max')) return;
    event.preventDefault();
    applyPrice(event);
  }, true);
})();

/* Decorate the deadline supplied by Globo without replacing its date data. */
(() => {
  const start = () => {
    document.querySelectorAll('.product__info').forEach(root => {
      let pointsBlock = root.querySelector('[id*="__gameball_product_points_"]');
      const decorate = () => {
        root.querySelectorAll("button.gBackInStockBtn").forEach(button => {
          if (!button.children.length && /^Email me when available$/i.test(button.textContent.trim())) {
            button.textContent = "Notify me when available";
          }
        });
        root.querySelectorAll('.singleProductPreOrderForm .gPreorderTopMessage').forEach(message => {
          if (message.querySelector('.ji-preorder-deadline-date')) return;
          const match = message.textContent.trim().match(/^(Pre[- ]Order ends)\s+(.+)$/i);
          if (!match || message.children.length) return;
          const label = document.createElement('span');
          label.className = 'ji-preorder-deadline-label';
          label.textContent = match[1];
          const date = document.createElement('span');
          date.className = 'ji-preorder-deadline-date';
          date.textContent = match[2];
          message.replaceChildren(label, document.createTextNode(' '), date);
        });
        root.querySelectorAll('.product__inventory .alert > span').forEach(text => {
          if (text.querySelector('.ji-release-date-value')) return;
          const match = text.textContent.trim().match(/^(Release:)\s+(.+)$/i);
          if (!match || text.children.length) return;
          const label = document.createElement('span');
          label.textContent = match[1];
          const date = document.createElement('span');
          date.className = 'ji-release-date-value';
          date.textContent = match[2];
          text.replaceChildren(label, document.createTextNode(' '), date);
          text.parentElement.classList.add('ji-release-date-bubble');
        });
        const deadline = root.querySelector('.singleProductPreOrderForm .gPreorderTopMessage');
        pointsBlock = root.querySelector('[id*="__gameball_product_points_"]') || pointsBlock;
        if (deadline?.textContent.trim() && pointsBlock && !pointsBlock.querySelector('form') && deadline.nextElementSibling !== pointsBlock) {
          deadline.after(pointsBlock);
        }
        root.querySelectorAll('.gb_prdct_pnts__text').forEach(text => {
          if (text.querySelector('.ji-points-amount')) return;
          const value = text.querySelector('b');
          if (!value || !/^Complete this Purchase to earn/i.test(text.textContent.trim())) return;
          const amount = document.createElement('span');
          amount.className = 'ji-points-amount';
          amount.append(value, document.createTextNode(' points'));
          text.replaceChildren(document.createTextNode('Earn '), amount, document.createTextNode(' with this purchase'));
        });
      };
      decorate();
      new MutationObserver(decorate).observe(root, {childList:true, subtree:true, characterData:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
